import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { IoIosClose } from "react-icons/io";
import apiClient from "../../service/Axios";

const NewProjectCreateModal = ({
  visible,
  setVisible,
  projectdetailsListFunc,
}) => {
  const [searchText, setSearchText] = useState("");
  const [tags, setTags] = useState([]);
  const [tagSuggestions, setTagSuggestions] = useState([]);
  const [value, setValue] = useState({
    title: "",
    description: "",
    tagslist: "",
    startdate: "",
    enddate: "",
  });

  useEffect(() => {
    apiClient
      .get(`${process.env.REACT_APP_API}/project/tag/list`)
      .then((res) => {
        setTagSuggestions(res.data);
      })
      .catch((error) => {
        console.error("Error fetching tag suggestions:", error);
      });
  }, []);
  // console.log("tagSuggestions", tagSuggestions);
  // const handleInputChange = (e) => {
  //   const inputText = e.target.value;
  //   setSearchText(inputText);

  //   // Filter tag suggestions based on input text
  //   const filteredSuggestions = tagSuggestions.filter(
  //     (tag) =>
  //       typeof tag === "string" &&
  //       tag.toLowerCase().includes(inputText.toLowerCase())
  //   );
  //   setTagSuggestions(filteredSuggestions);
  // };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      if (searchText.trim() !== "") {
        setTags([...tags, searchText.trim()]);
        setSearchText("");
      }
    }
  };

  const handleTagRemove = (tagToRemove) => {
    const updatedTags = tags.filter((tag) => tag !== tagToRemove);
    setTags(updatedTags);
  };

  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleInputChange = (e) => {
    const inputText = e.target.value;
    setSearchText(inputText);

    // Filter tag suggestions based on input text
    const filteredSuggestions = tagSuggestions.filter(
      (tag) =>
        typeof tag === "string" &&
        tag.toLowerCase().includes(inputText.toLowerCase())
    );
    setTagSuggestions(filteredSuggestions);
    setShowSuggestions(true);
  };

  const handleSuggestionClick = (suggestion) => {
    setTags([...tags, suggestion]);
    setSearchText("");
    setShowSuggestions(false);
  };
  const handleProjectCreate = (e) => {
    e.preventDefault();
    const data = {
      title: value.title,
      description: value.description,
      tagslist: tags,
      startdate: value.startdate,
      enddate: value.enddate,
    };
    // console.log(data);

    apiClient
      .post(`${process.env.REACT_APP_API}/project/create`, data)
      .then((res) => {
        // console.log("new project", res.data);
        projectdetailsListFunc();
        setValue("");
      });
  };
  return (
    <div className="card flex justify-content-center">
      <Dialog
        header="Create new project"
        visible={visible}
        style={{
          width: "50vw",
          background: "#fff",
          color: "black",
          padding: "20px 30px",
          marginBottom: "20px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        }}
        onHide={() => setVisible(false)}>
        <form
          onSubmit={handleProjectCreate}
          className="grid grid-cols-1 gap-5 space-y-0.5 my-10 mx-10 text-black">
          <div className="relative">
            <label>Title:</label>
            <input
              name="title"
              type="text"
              value={value.title}
              onChange={(e) => {
                setValue((prev) => ({ ...prev, title: e.target.value }));
              }}
              placeholder="Project title ..."
              className="input w-full input-bordered pl-5 rounded-md mt-1"
              required
            />
          </div>
          <div className="relative">
            <label>description:</label>
            <input
              name="description"
              type="text"
              value={value.description}
              onChange={(e) => {
                setValue((prev) => ({ ...prev, description: e.target.value }));
              }}
              placeholder="Project description..."
              className="input w-full input-bordered pl-5 rounded-md mt-1"
              required
            />
          </div>
          {/* <div className="relative">
            <label>Tag:</label>
            <div className="my-1 flex justify-normal items-center gap-2">
              {tags.map((tag, index) => (
                <div
                  key={index}
                  className="flex justify-normal items-center gap-2 bg-[#161B22] text-white px-2 py-1 m-1 rounded">
                  <p>{tag}</p>
                  <IoIosClose onClick={() => handleTagRemove(tag)} />
                </div>
              ))}
            </div>
            <input
              type="text"
              value={searchText}
              onChange={handleInputChange}
              onKeyDown={handleInputKeyDown}
              className="input w-full input-bordered pl-5 rounded-md mt-1"
              placeholder="Type and press Enter or comma to add words"
            />
          </div> */}

          <div className="relative">
            <label>Tag:</label>
            <div className="my-1 flex justify-normal items-center gap-2">
              {tags.map((tag, index) => (
                <div
                  key={index}
                  className="flex justify-normal items-center gap-2 bg-[#161B22] text-white px-2 py-1 m-1 rounded">
                  <p>{tag}</p>
                  <IoIosClose onClick={() => handleTagRemove(tag)} />
                </div>
              ))}
            </div>
            <input
              type="text"
              value={searchText}
              onChange={handleInputChange}
              onKeyDown={handleInputKeyDown}
              className="input w-full input-bordered pl-5 rounded-md mt-1"
              placeholder="Type and press Enter or comma to add words"
            />

            {/* Tag suggestions dropdown */}
            {/* {showSuggestions && (
              <ul className="tag-suggestions bg-red-500 w-1/2 h-10">
                {tagSuggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion)}>
                    {suggestion}
                  </li>
                ))}
              </ul>
            )} */}
            {/* <div className="my-1 flex justify-normal items-center gap-2">
              {tags.map((tag, index) => (
                <div
                  key={index}
                  className="flex justify-normal items-center gap-2 bg-[#161B22] text-white px-2 py-1 m-1 rounded">
                  <p>{tag}</p>
                  <IoIosClose onClick={() => handleTagRemove(tag)} />
                </div>
              ))}
            </div>
            <input
              type="text"
              value={searchText}
              onChange={handleInputChange}
              onKeyDown={handleInputKeyDown}
              className="input w-full input-bordered pl-5 rounded-md mt-1"
              placeholder="Type and press Enter or comma to add words"
            /> */}
            {/* Tag suggestions dropdown */}
            {/* {searchText && (
              <ul className="tag-suggestions">
                {tagSuggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    onClick={() => setTags([...tags, suggestion])}>
                    {suggestion}
                  </li>
                ))}
              </ul>
            )} */}
          </div>

          <div className="grid grid-cols-2 gap-5">
            <div className="relative">
              <label>StartDate:</label>
              <input
                name="startdate"
                type="date"
                value={value.startdate}
                onChange={(e) => {
                  setValue((prev) => ({
                    ...prev,
                    startdate: e.target.value,
                  }));
                }}
                placeholder="type here patient mobile no. ..."
                className="input w-full input-bordered pl-5 rounded-md mt-1"
                required
              />
            </div>
            <div className="relative">
              <label>EndDate:</label>
              <input
                name="enddate"
                type="date"
                value={value.enddate}
                onChange={(e) => {
                  setValue((prev) => ({
                    ...prev,
                    enddate: e.target.value,
                  }));
                }}
                placeholder="type here patient mobile no. ..."
                className="input w-full input-bordered pl-5 rounded-md mt-1"
                required
              />
            </div>
          </div>

          <input
            className="bg-[#161B22] py-2 text-white rounded-[4px] w-full mt-5"
            onClick={() => setVisible(false)}
            type="submit"
            value="Submit"
          />
        </form>
      </Dialog>
    </div>
  );
};

export default NewProjectCreateModal;
